/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConditionType = "contains" | "endsWith" | "equals" | "greaterThan" | "greaterThanOrEqual" | "inRange" | "lessThan" | "lessThanOrEqual" | "notContains" | "notEqual" | "startsWith" | "%future added value";
export type FilterType = "date" | "number" | "text" | "%future added value";
export type OperatorType = "AND" | "OR" | "%future added value";
export type Sort = {|
  colId?: ?string,
  sort?: ?string,
|};
export type Filter = {|
  name: string,
  filterType: FilterType,
  operator: OperatorType,
  denySelection?: ?boolean,
  conditions: $ReadOnlyArray<?Condition>,
|};
export type Condition = {|
  value: $ReadOnlyArray<?string>,
  type: ConditionType,
|};
export type SearchContainerQueryVariables = {|
  startRow?: ?number,
  endRow?: ?number,
  sortModel?: ?$ReadOnlyArray<?Sort>,
  Invoicesfilters?: ?$ReadOnlyArray<?Filter>,
  SearchInvoices: boolean,
  SearchInvoicesCount: boolean,
  HouseEntrancesfilters?: ?$ReadOnlyArray<?Filter>,
  SearchHouseEntrances: boolean,
  SearchHouseEntrancesCount: boolean,
  Appointmentsfilters?: ?$ReadOnlyArray<?Filter>,
  SearchAppointments: boolean,
  SearchAppointmentsCount: boolean,
  Tenantsfilters?: ?$ReadOnlyArray<?Filter>,
  TenantsSubfilters?: ?$ReadOnlyArray<?Filter>,
  SearchTenants: boolean,
  SearchTenantsCount: boolean,
  CustomerNumbersfilters?: ?$ReadOnlyArray<?Filter>,
  SearchCustomerNumbers: boolean,
  SearchCustomerNumbersCount: boolean,
  companyId: string,
|};
export type SearchContainerQueryResponse = {|
  +Me: ?{|
    +id: string,
    +Company: ?{|
      +CountInvoicesSearch?: ?number,
      +InvoicesSearch?: ?$ReadOnlyArray<?{|
        +id: string,
        +tableId: number,
        +invoiceNumber: ?string,
        +name: ?string,
      |}>,
      +CountHouseEntrancesSearch?: ?number,
      +HouseEntrancesSearch?: ?$ReadOnlyArray<?{|
        +id: string,
        +tableId: number,
        +address: ?{|
          +street: string,
          +zip: string,
          +city: string,
          +number: string,
        |},
      |}>,
      +CountAppointmentsSearch?: number,
      +AppointmentsSearch?: ?$ReadOnlyArray<?{|
        +id: ?string,
        +tableId: ?number,
        +referenceNumber: ?string,
        +tenant: ?{|
          +id: ?string,
          +firstname: string,
          +lastname: string,
          +fullname: ?string,
        |},
        +address: ?{|
          +street: string,
          +zip: string,
          +city: string,
          +number: string,
        |},
      |}>,
      +CountTenantsSearch?: ?number,
      +TenantsSearch?: ?$ReadOnlyArray<?{|
        +id: string,
        +tableId: number,
        +referenceNumber: string,
        +tenants: $ReadOnlyArray<?{|
          +id: ?string,
          +tableId: ?number,
          +firstname: string,
          +lastname: string,
          +fullname: ?string,
        |}>,
        +address: ?{|
          +street: string,
          +zip: string,
          +city: string,
          +number: string,
        |},
      |}>,
      +CountCustomerNumbersSearch?: ?number,
      +CustomerNumbersSearch?: ?$ReadOnlyArray<?{|
        +id: string,
        +tableId: number,
        +referenceNumber: string,
        +address: ?{|
          +street: string,
          +zip: string,
          +city: string,
          +number: string,
        |},
      |}>,
    |},
  |}
|};
export type SearchContainerQuery = {|
  variables: SearchContainerQueryVariables,
  response: SearchContainerQueryResponse,
|};
*/


/*
query SearchContainerQuery(
  $startRow: Int
  $endRow: Int
  $sortModel: [Sort]
  $Invoicesfilters: [Filter]
  $SearchInvoices: Boolean!
  $SearchInvoicesCount: Boolean!
  $HouseEntrancesfilters: [Filter]
  $SearchHouseEntrances: Boolean!
  $SearchHouseEntrancesCount: Boolean!
  $Appointmentsfilters: [Filter]
  $SearchAppointments: Boolean!
  $SearchAppointmentsCount: Boolean!
  $Tenantsfilters: [Filter]
  $TenantsSubfilters: [Filter]
  $SearchTenants: Boolean!
  $SearchTenantsCount: Boolean!
  $CustomerNumbersfilters: [Filter]
  $SearchCustomerNumbers: Boolean!
  $SearchCustomerNumbersCount: Boolean!
  $companyId: ID!
) {
  Me {
    id
    Company(id: $companyId) {
      CountInvoicesSearch: countInvoices(options: {filters: $Invoicesfilters}) @include(if: $SearchInvoicesCount)
      InvoicesSearch: Invoices(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $Invoicesfilters}) @include(if: $SearchInvoices) {
        id
        tableId
        invoiceNumber
        name
      }
      CountHouseEntrancesSearch: countHouseEntrances(options: {filters: $HouseEntrancesfilters}) @include(if: $SearchHouseEntrancesCount)
      HouseEntrancesSearch: HouseEntrances(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $HouseEntrancesfilters}) @include(if: $SearchHouseEntrances) {
        id
        tableId
        address {
          street
          zip
          city
          number
        }
      }
      CountAppointmentsSearch: countAppointments(options: {filters: $Appointmentsfilters}) @include(if: $SearchAppointmentsCount)
      AppointmentsSearch: Appointments(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $Appointmentsfilters}) @include(if: $SearchAppointments) {
        id
        tableId
        referenceNumber
        tenant {
          id
          firstname
          lastname
          fullname
        }
        address {
          street
          zip
          city
          number
        }
      }
      CountTenantsSearch: countUsageUnits(options: {filters: $Tenantsfilters}) @include(if: $SearchTenantsCount)
      TenantsSearch: UsageUnits(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $Tenantsfilters}) @include(if: $SearchTenants) {
        id
        tableId
        referenceNumber
        tenants(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $TenantsSubfilters}) {
          id
          tableId
          firstname
          lastname
          fullname
        }
        address {
          street
          zip
          city
          number
        }
      }
      CountCustomerNumbersSearch: countUsageUnits(options: {filters: $CustomerNumbersfilters}) @include(if: $SearchCustomerNumbersCount)
      CustomerNumbersSearch: UsageUnits(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $CustomerNumbersfilters}) @include(if: $SearchCustomerNumbers) {
        id
        tableId
        referenceNumber
        address {
          street
          zip
          city
          number
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "Appointmentsfilters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "CustomerNumbersfilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "HouseEntrancesfilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "Invoicesfilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchAppointments"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchAppointmentsCount"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchCustomerNumbers"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchCustomerNumbersCount"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchHouseEntrances"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchHouseEntrancesCount"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchInvoices"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchInvoicesCount"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchTenants"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SearchTenantsCount"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "TenantsSubfilters"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "Tenantsfilters"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endRow"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortModel"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startRow"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v21 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v22 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "Invoicesfilters"
},
v23 = {
  "condition": "SearchInvoicesCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "CountInvoicesSearch",
      "args": [
        {
          "fields": [
            (v22/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "kind": "ScalarField",
      "name": "countInvoices",
      "storageKey": null
    }
  ]
},
v24 = {
  "kind": "Variable",
  "name": "endRow",
  "variableName": "endRow"
},
v25 = {
  "kind": "Variable",
  "name": "sorting",
  "variableName": "sortModel"
},
v26 = {
  "kind": "Variable",
  "name": "startRow",
  "variableName": "startRow"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tableId",
  "storageKey": null
},
v28 = {
  "condition": "SearchInvoices",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "InvoicesSearch",
      "args": [
        {
          "fields": [
            (v24/*: any*/),
            (v22/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "concreteType": "Invoice",
      "kind": "LinkedField",
      "name": "Invoices",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v29 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "HouseEntrancesfilters"
},
v30 = {
  "condition": "SearchHouseEntrancesCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "CountHouseEntrancesSearch",
      "args": [
        {
          "fields": [
            (v29/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "kind": "ScalarField",
      "name": "countHouseEntrances",
      "storageKey": null
    }
  ]
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zip",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "condition": "SearchHouseEntrances",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "HouseEntrancesSearch",
      "args": [
        {
          "fields": [
            (v24/*: any*/),
            (v29/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "concreteType": "HouseEntrance",
      "kind": "LinkedField",
      "name": "HouseEntrances",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v27/*: any*/),
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v33 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "Appointmentsfilters"
},
v34 = {
  "condition": "SearchAppointmentsCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "CountAppointmentsSearch",
      "args": [
        {
          "fields": [
            (v33/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "kind": "ScalarField",
      "name": "countAppointments",
      "storageKey": null
    }
  ]
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referenceNumber",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastname",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullname",
  "storageKey": null
},
v39 = {
  "condition": "SearchAppointments",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "AppointmentsSearch",
      "args": [
        {
          "fields": [
            (v24/*: any*/),
            (v33/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "Appointments",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v27/*: any*/),
        (v35/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Tenant",
          "kind": "LinkedField",
          "name": "tenant",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v36/*: any*/),
            (v37/*: any*/),
            (v38/*: any*/)
          ],
          "storageKey": null
        },
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v40 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "Tenantsfilters"
},
v41 = {
  "condition": "SearchTenantsCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "CountTenantsSearch",
      "args": [
        {
          "fields": [
            (v40/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "kind": "ScalarField",
      "name": "countUsageUnits",
      "storageKey": null
    }
  ]
},
v42 = {
  "condition": "SearchTenants",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "TenantsSearch",
      "args": [
        {
          "fields": [
            (v24/*: any*/),
            (v40/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "concreteType": "UsageUnit",
      "kind": "LinkedField",
      "name": "UsageUnits",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v27/*: any*/),
        (v35/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "fields": [
                (v24/*: any*/),
                {
                  "kind": "Variable",
                  "name": "filters",
                  "variableName": "TenantsSubfilters"
                },
                (v25/*: any*/),
                (v26/*: any*/)
              ],
              "kind": "ObjectValue",
              "name": "options"
            }
          ],
          "concreteType": "Tenant",
          "kind": "LinkedField",
          "name": "tenants",
          "plural": true,
          "selections": [
            (v20/*: any*/),
            (v27/*: any*/),
            (v36/*: any*/),
            (v37/*: any*/),
            (v38/*: any*/)
          ],
          "storageKey": null
        },
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v43 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "CustomerNumbersfilters"
},
v44 = {
  "condition": "SearchCustomerNumbersCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "CountCustomerNumbersSearch",
      "args": [
        {
          "fields": [
            (v43/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "kind": "ScalarField",
      "name": "countUsageUnits",
      "storageKey": null
    }
  ]
},
v45 = {
  "condition": "SearchCustomerNumbers",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "CustomerNumbersSearch",
      "args": [
        {
          "fields": [
            (v24/*: any*/),
            (v43/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "options"
        }
      ],
      "concreteType": "UsageUnit",
      "kind": "LinkedField",
      "name": "UsageUnits",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v27/*: any*/),
        (v35/*: any*/),
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          {
            "alias": null,
            "args": (v21/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              (v28/*: any*/),
              (v30/*: any*/),
              (v32/*: any*/),
              (v34/*: any*/),
              (v39/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v19/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Operation",
    "name": "SearchContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          {
            "alias": null,
            "args": (v21/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v23/*: any*/),
              (v28/*: any*/),
              (v30/*: any*/),
              (v32/*: any*/),
              (v34/*: any*/),
              (v39/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a1b52cd89f6dbb5862a714957efe586",
    "id": null,
    "metadata": {},
    "name": "SearchContainerQuery",
    "operationKind": "query",
    "text": "query SearchContainerQuery(\n  $startRow: Int\n  $endRow: Int\n  $sortModel: [Sort]\n  $Invoicesfilters: [Filter]\n  $SearchInvoices: Boolean!\n  $SearchInvoicesCount: Boolean!\n  $HouseEntrancesfilters: [Filter]\n  $SearchHouseEntrances: Boolean!\n  $SearchHouseEntrancesCount: Boolean!\n  $Appointmentsfilters: [Filter]\n  $SearchAppointments: Boolean!\n  $SearchAppointmentsCount: Boolean!\n  $Tenantsfilters: [Filter]\n  $TenantsSubfilters: [Filter]\n  $SearchTenants: Boolean!\n  $SearchTenantsCount: Boolean!\n  $CustomerNumbersfilters: [Filter]\n  $SearchCustomerNumbers: Boolean!\n  $SearchCustomerNumbersCount: Boolean!\n  $companyId: ID!\n) {\n  Me {\n    id\n    Company(id: $companyId) {\n      CountInvoicesSearch: countInvoices(options: {filters: $Invoicesfilters}) @include(if: $SearchInvoicesCount)\n      InvoicesSearch: Invoices(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $Invoicesfilters}) @include(if: $SearchInvoices) {\n        id\n        tableId\n        invoiceNumber\n        name\n      }\n      CountHouseEntrancesSearch: countHouseEntrances(options: {filters: $HouseEntrancesfilters}) @include(if: $SearchHouseEntrancesCount)\n      HouseEntrancesSearch: HouseEntrances(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $HouseEntrancesfilters}) @include(if: $SearchHouseEntrances) {\n        id\n        tableId\n        address {\n          street\n          zip\n          city\n          number\n        }\n      }\n      CountAppointmentsSearch: countAppointments(options: {filters: $Appointmentsfilters}) @include(if: $SearchAppointmentsCount)\n      AppointmentsSearch: Appointments(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $Appointmentsfilters}) @include(if: $SearchAppointments) {\n        id\n        tableId\n        referenceNumber\n        tenant {\n          id\n          firstname\n          lastname\n          fullname\n        }\n        address {\n          street\n          zip\n          city\n          number\n        }\n      }\n      CountTenantsSearch: countUsageUnits(options: {filters: $Tenantsfilters}) @include(if: $SearchTenantsCount)\n      TenantsSearch: UsageUnits(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $Tenantsfilters}) @include(if: $SearchTenants) {\n        id\n        tableId\n        referenceNumber\n        tenants(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $TenantsSubfilters}) {\n          id\n          tableId\n          firstname\n          lastname\n          fullname\n        }\n        address {\n          street\n          zip\n          city\n          number\n        }\n      }\n      CountCustomerNumbersSearch: countUsageUnits(options: {filters: $CustomerNumbersfilters}) @include(if: $SearchCustomerNumbersCount)\n      CustomerNumbersSearch: UsageUnits(options: {startRow: $startRow, endRow: $endRow, sorting: $sortModel, filters: $CustomerNumbersfilters}) @include(if: $SearchCustomerNumbers) {\n        id\n        tableId\n        referenceNumber\n        address {\n          street\n          zip\n          city\n          number\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f697f6b2c2bff471df2c14723aa91507';

module.exports = node;
